import { gql } from '@apollo/client'

export const FETCH_CONVERSATION_ATTACHMENTS = gql`
  query ConversationAttachments($conversationId: ID!) {
    conversationAttachments(conversationId: $conversationId) {
      id
      messageId
      name
      extension
      fileUrl
      creationDate
      description
    }
  }
`
